import React, { useState } from 'react';
import * as cls from './why-it-matters.module.css';
import { IMG_PATH } from '../../../../constants';
import { Section } from '../../../../ui/components/section';
import { Typography } from '../../../../ui/components/typography';

const itemsUtilities = [
  {
    title: 'Increase digital engagement',
    text: 'with appliance-level journeys that improve app adoption, satisfaction, and retention.',
  },
  {
    title: 'Reduce cost-to-serve',
    text: 'by lowering high-bill contacts through clearer, appliance-level explanations.',
  },
  {
    title: 'Target offers and programmes with confidence',
    text: '(EVs, heat pumps, efficient appliances, tariffs) using verified usage patterns and segments.',
  },
];

const itemsHouseholds = [
  {
    title: 'See where your money goes',
    text: (
      <>
        with clear <b>bill breakdowns by appliance.</b>
      </>
    ),
  },
  {
    title: 'Cut wasted energy with intelligent insights',
    text: 'that reveal what’s consuming power unnecessarily.',
  },
  {
    title: 'Feel safer at home',
    text: (
      <>
        with unusual-use notifications and optional{' '}
        <b>elderly activity signals.</b>
      </>
    ),
  },
];

export const WhyItMatters = () => {
  const [active] = useState(0);

  return (
    <Section classNameRoot={cls.section}>
      <Typography as="h1" tag="h2">
        Why It Matters for Utilities
      </Typography>

      {/* <div className={cls.buttons}>
        <h3>
          <button
            className={active === 0 ? cls['button--active'] : ''}
            onClick={() => setActive(0)}
          >
            For Utilities
          </button>
        </h3>
        <h3>
          <button
            className={active === 1 ? cls['button--active'] : ''}
            onClick={() => setActive(1)}
          >
            For Households
          </button>
        </h3>
      </div>*/}

      <div className={cls.wrapper}>
        <div className={active === 0 ? cls['wrapper--active'] : ''}>
          <img
            alt=""
            src={`${IMG_PATH}/our-technology/energy-intelligence/why-it-matters-1.png`}
          />
          <ul className={cls.list}>
            {itemsUtilities.map((item, index) => (
              <li key={index}>
                <Typography>{item.title}</Typography>
                <Typography>{item.text}</Typography>
              </li>
            ))}
          </ul>
        </div>
        <div className={active === 1 ? cls['wrapper--active'] : ''}>
          <img
            alt=""
            src={`${IMG_PATH}/our-technology/energy-intelligence/why-it-matters-2.png`}
          />
          <ul className={cls.list}>
            {itemsHouseholds.map((item, index) => (
              <li key={index}>
                <Typography>{item.title}</Typography>
                <Typography>{item.text}</Typography>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </Section>
  );
};
